import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';
const state = {
	user: null,
	loading: false,
	error: null,
	token: null
}
const vuexLocalStorage = new VuexPersist({
	key: 'vuex',
	storage: window.localStorage,
	reducer: state => ({
		user: state.user,
		token: state.token
	})
})
export default new Vuex.Store({
	state: state,
	getters: {
		user (state) {
			return state.user;
		},
		loading (state) {
			return state.loading;
		},
		error (state) {
			return state.error;
		},
		token (state) {
			return state.token;
		}
	},
	actions: {
		startLoading ({commit}) {
			commit('setLoading', true);
		},
		stopLoading ({commit}) {
			commit('setLoading', false);
		},
		setUser ({commit}, user) {
			commit('setUser', user);
		},
		clearUser ({commit}) {
			commit('setUser', null);
		},
		setError ({commit}, error) {
			commit('setError', error);
		},
		clearError ({commit}) {
			commit('setError', null);
		},
		setToken ({commit}, token) {
			commit('setToken', token);
		}
	},
	mutations: {
		setUser (state, value) {
			state.user = value;
		},
		setLoading (state, value) {
			state.loading = value;
		},
		setError (state, value) {
			state.error = value;
		},
		setToken (state, value) {
			state.token = value;
		}
	},
	plugins: [vuexLocalStorage.plugin],
	strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js